import { useState, useEffect } from 'react';
import config from '../config';

const PWA_MODE = import.meta.env.MODE;

declare global {
	interface Window {
		sw: any;
	}
}

/**
 * React hook that returns the navigator service worker
 *
 * @return {ServiceWorker} The service worker
 *
 */
export function useServiceWorker(): ServiceWorker | null {
	const [sw, setSw] = useState<ServiceWorker | null>(null);

	useEffect(() => {
		if ('serviceWorker' in navigator) {
			if (PWA_MODE === 'production') {
				const host =
					window.location.protocol + '//' + window.location.host;
				const scopeUrl = config.build.subdirectory
					? `${config.build.subdirectory}`
					: '/';

				const assetDirectory = `/sw.js?v=${config.build.version}`;
				console.log(`SW REGISTRATION: `, {
					scopeUrl,
					assetDirectory,
					host,
				});
				navigator.serviceWorker
					.register(assetDirectory, {
						scope: scopeUrl,
					})
					.then((reg) => {
						console.log(`SUCCESSFUL REGISTATION`, reg);
					})
					.catch(console.error);
			}
			navigator.serviceWorker.ready
				.then((registration) => {
					console.log(`REGISTRATION`, registration);
					window.sw = registration.active;
					setSw(registration.active);
				})
				.catch((err) => {
					console.log(`Service worker error`);
					console.error(err);
				});
		}
	}, []);

	return sw;
}
